export enum CustodiansRoutes {
  CreateOne = 'create-one',
  Search = 'search',
  UpdateOne = 'update-one',
}
